export default "__VITE_ASSET__vcS5skZG__";